<template>
  <div class="body-acao">
    <div id="menu">
      <div v-for="menuItem in menu">
        <button
          class="menu-item"
          :class="{ 'menu-item-selecionado': menuAtivo == menuItem.valorMenu }"
          @click="abrirMenu(menuItem)"
        >
          {{ menuItem.valorMenu }}
        </button>
      </div>
    </div>
    <div id="conteudo">
      <div v-if="menuAtivo == ''">
        <h2>Central do coordenador</h2>
      </div>
      <RouterView />
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import router from "@/router";
import { useRoute } from "vue-router";

const props = defineProps({
  acaoId: {
    type: String,
    required: true,
  },
});

const route = useRoute();

const menu = ref([
  {
    valorMenu: "Atividades",
    valorRota: "atividades-central-coordenacao",
  },
  /*
  {
    valorMenu: "Tarefas",
    valorRota: "tarefas-central-coordenacao",
  },
  */
  {
    valorMenu: "Noticías",
    valorRota: "noticias-central-coordenacao",
  },
]);
const menuAtivo = ref("Atividades");

function abrirMenu(menu) {
  router.push({ name: menu.valorRota });
  menuAtivo.value = menu.valorMenu;
}

watch(
  () => props.acaoId,
  (acaoId) => {
    if (acaoId) {
      props.acaoId = acaoId;
    }
  },
  { immediate: true } // faz a primeira chamada assim que o componente monta
);

onMounted(() => {
  const rota = route.path.split("/");

  menuAtivo.value = rota[rota.length - 1];
});
</script>

<style scoped>
.body-acao {
  display: flex !important;
  flex-direction: row !important;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
}

#menu {
  width: 20%;
  height: min-content;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.menu-item {
  width: 100%;
  padding: 10px 10px;
  background-color: white;
  border-radius: 10px;
  border: none;
  text-align: start;
}

.menu-item:hover {
  background-color: var(--azul-escuro);
  color: white;
  transition: 300ms;
}

.menu-item-selecionado {
  background-color: var(--azul-escuro);
  color: white;
  border-right: 2px solid white;
}

#conteudo {
  width: 100%;
  border-radius: 20px;
  min-height: 30vh;
  background-color: white;
  color: white;
  padding: 2%;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
}

h2 {
  text-align: center;
}
</style>
